import { Typography } from '@mui/material';

import locales from '../../../../../../constants/commonLocales';

const CostColumnHeader = () => <Typography variant="h3">{locales.table.column.cost}</Typography>;

export default CostColumnHeader;
